import { Attachment } from './attachment.model';
import {
  ContentSharingInput,
  ContentSharingOverview
} from './customer-portal/customer-portal.model';
import { TargetGroup } from './faq.model';
import { PinnedContentType } from './pinned-content-type.enum';

export interface Offer {
  id?: number;
  data?: OfferData;
  publishedAt?: string;
  timeAt?: string;
  publishedUntil?: string;
  timeUntil?: string;
  sharing?: ContentSharingInput;
  pinned?: boolean;
  pinnedStartDate?: string;
  pinnedEndDate?: string;
  pinnedContentType?: PinnedContentType;
  pinnedPosition?: number;
}

export interface OffersOverview {
  id?: number;
  title?: string;
  url?: string;
  publishedAt?: string;
  publishedUntil?: string;
  sharings?: ContentSharingOverview;
  pinnedStartDate?: string;
  pinnedEndDate?: string;
  pinnedContentType?: PinnedContentType;
  pinnedPosition?: number;
}

export interface AdditionalProp {
  href: string;
  hreflang: string;
  title: string;
  type: string;
  deprecation: string;
  profile: string;
  name: string;
  templated: boolean;
}

export interface OfferData {
  title?: string;
  showInHeader?: boolean;
  excerpt?: string;
  image?: Attachment;
  titleImageId?: string;
  text?: string;
  href?: string;
  linkText?: string;
  sendNotification?: boolean;
}

export interface OffersOverviewOnPrem {
  id?: number;
  uuid?: string;
  data?: OfferDataOnPrem;
  publishedAt?: string;
  publishedUntil?: string;
  sharing?: ContentSharingInput;
  _links?: AdditionalProps;
  sendNotification?: boolean;
}

export interface OfferDataOnPrem {
  title?: string;
  showInHeader?: boolean;
  excerpt?: string;
  image?: Attachment;
  imageUrl?: string;
  body?: string;
  href?: string;
}

export interface AdditionalProps {
  additionalProp1: AdditionalProp;
  additionalProp2: AdditionalProp;
  additionalProp3: AdditionalProp;
}

export interface OffersInput {
  data: OfferData;
  publishedAt?: string | Date;
  publishedUntil?: string | Date;
  targetGroups: TargetGroup[];
  pinned?: boolean;
  pinnedStartDate?: string;
  pinnedEndDate?: string;
}

export interface OffersInputOnPrem {
  data: OfferData;
  publishedAt?: string | Date;
  publishedUntil?: string | Date;
  targetGroups: TargetGroup[];
  sendNotification?: boolean;
}

export enum TargetGroupType {
  TENANT,
  OWNER,
  ADMINISTRATION_UNIT
}

export interface OfferFiles {
  document: Attachment;
}

export interface BulkDeleteInput {
  contentDeleteIds: number[];
}
